import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from './components/authentication.js';    

import Login from "./Login";

import Mainpage from "./qrreader";
import Dashboard from "./dashboard";
import Detailspage from "./qrdetails";
import ControlPage from "./controlroom.new";
import VenueDetailsPage from "./venuedetails";
import ClubReader from "./clubReader";  


import { useAuth } from './components/authentication.js';
import GoodieBagScanner from "./goodiebagscanner";
import GoodieBagDetails from "./goodiebagdetails";

function PrivateRoute({ children, allowedRoles }) {
  const { currentUser, userRole, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!currentUser) return <Navigate to="/login" />;
  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" />;
  }
  return children;
}

function AdminRoute({ children }) {
  // Only allow users with 'admin' role
  return <PrivateRoute allowedRoles={["admin"]}>{children}</PrivateRoute>;
}
function App() {
  return (
    <div className="app">
      <Router>
        <AuthProvider>
        <Routes>
           <Route exact path="/" element={<AdminRoute><Dashboard /></AdminRoute>} />  
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />          
           <Route exact path="/controlroom" element={<AdminRoute><ControlPage/></AdminRoute>} />
           <Route exact path="/rmqrreader" element={<AdminRoute><Mainpage/></AdminRoute>} />
           <Route exact path="/rmqrdetails" element={<AdminRoute><Detailspage/></AdminRoute>} />
           <Route exact path="/venuedetails" element={<AdminRoute><VenueDetailsPage/></AdminRoute>} />
           <Route exact path="/clubReader" element={<AdminRoute><ClubReader/></AdminRoute>} />
      
            <Route path="/goodiebagscanner"  element={<AdminRoute>
              <GoodieBagScanner />
            </AdminRoute>} />
            <Route path="/goodiebagdetails"  element={<AdminRoute>
              <GoodieBagDetails />
            </AdminRoute>} />
      </Routes>
      </AuthProvider>
      </Router>
    </div> 
  );
} 
export default App;